module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0095.jpg?v=ddd8f39a";